var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23276 13.9216L5.37549 10.0634L6.66094 8.77796L9.23276 11.3489L14.3746 6.20615L15.6609 7.49251L9.23276 13.9198V13.9216Z",
    fill: "#75F94C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.830078 10C0.830078 4.47727 5.30735 0 10.8301 0C16.3528 0 20.8301 4.47727 20.8301 10C20.8301 15.5227 16.3528 20 10.8301 20C5.30735 20 0.830078 15.5227 0.830078 10ZM10.8301 18.1818C9.75563 18.1818 8.6917 17.9702 7.69903 17.559C6.70637 17.1478 5.80441 16.5452 5.04466 15.7854C4.28491 15.0257 3.68224 14.1237 3.27106 13.131C2.85989 12.1384 2.64826 11.0745 2.64826 10C2.64826 8.92555 2.85989 7.86162 3.27106 6.86895C3.68224 5.87629 4.28491 4.97433 5.04466 4.21458C5.80441 3.45483 6.70637 2.85216 7.69903 2.44099C8.6917 2.02981 9.75563 1.81818 10.8301 1.81818C13 1.81818 15.0811 2.68019 16.6155 4.21458C18.1499 5.74897 19.0119 7.83005 19.0119 10C19.0119 12.17 18.1499 14.251 16.6155 15.7854C15.0811 17.3198 13 18.1818 10.8301 18.1818Z",
    fill: "#75F94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.9120a8212ebddbcfde7f5730bf8f838c.svg";
export { ForwardRef as ReactComponent };